import { render, staticRenderFns } from "./detailsQuizzLocal.vue?vue&type=template&id=ee01f718&"
import script from "./detailsQuizzLocal.vue?vue&type=script&lang=js&"
export * from "./detailsQuizzLocal.vue?vue&type=script&lang=js&"
import style0 from "./detailsQuizzLocal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports